// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Op11","importantInfo":"styles_importantInfo__2ZtCv"};